<template>
  <div>
    <world-nav/>
    <b-card title="仮想異世界創造">
      <b-card-text>
        <p>
          仮想環境を作成し、管理用アカウントでログインします。
          登録＋テストを押下すると、仮想環境に遷移します。
        </p>
      </b-card-text>
      <b-card v-for="(v,i) in innerValue.test.account" :key="i"
        :title="`管理アカウント${i+1}`"
        :class="{off:v.location==null}">
        <b-form-group label="愛称">
          <b-form-input v-model="v.nickname" />
        </b-form-group>
        <b-form-group label="場所">
          <b-form-select :options="areas" v-model="v.location" />
        </b-form-group>
        <b-form-group label="ステータス">
          <b-container>
            <!-- 固定ステータス -->
            <b-row v-for="(k,j) in chunk2fixStatus" :key="'f'+j">
              <b-col cols="6" v-for="l in k" :key="'fs'+l">
                <b-input-group :prepend="l">
                  <b-form-input type="number" v-model="v.status[l]" 
                    number />
                </b-input-group>
              </b-col>
            </b-row>
            <!-- 拡張ステータス -->
            <b-row v-for="(k,j) in chunk4statusWithoutFixStatus(v)" :key="'o'+j">
              <b-col cols="6" v-for="l in k" :key="'os'+l">
                <b-input-group :prepend="l">
                  <b-form-input type="number" v-model="v.status[l]" 
                    number />
                  <b-input-group-append>
                    <b-button variant="danger" @click="$delete(v.status, l)">
                      <font-awesome-icon icon="times" class="icon fa-1x" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-input-group>
                  <b-form-input v-model="newStatusLabel[i]" 
                    :state="okStatusLabel(newStatusLabel[i])"
                    placeholder="ステータス名" />
                  <b-input-group-append>
                    <b-button @click="newStatus(v,i)">
                      <font-awesome-icon icon="plus-square" class="fa-1x p-0" />
                      追加
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </b-container>          
        </b-form-group>
      </b-card>
    </b-card>

    <b-button type="button" variant="primary" @click="$emit('test')">登録＋テスト</b-button>
    <response-message ref="response" :value="postMessage" />
  </div>
</template>

<script>
// import store from '@/store'
import WorldNav from '@/components/WorldNav'
import ResponseMessage from '@/components/ResponseMessage'
import mixinPlayer from './mixin-player'
import { areas, fixStatus } from './mixin-editor'
import _ from 'lodash'
export default {
  components: {
    WorldNav,
    ResponseMessage
  },
  mixins: [mixinPlayer, areas, fixStatus],
  props: {
    value: Object,
    postMessage: Object,
    max: { type:Number, default:4 }
  },
  data () {
    return {
      innerValue: this.value,
      newStatusLabel: _.fill(Array(this.value.test.account.length),'')
    }
  },
  methods: {
    chunk4statusWithoutFixStatus (v) {
      return _.chunk(_.difference(_.keys(v.status),fixStatus),2)
    },
    newStatus (v,i) {
      this.$set(v.status,this.newStatusLabel[i],0)
      this.newStatusLabel[i] = ""
    },
    okStatusLabel (v) {
      return v != ""
    },
    addAccount () {
      if(this.innerValue.test.account.length < this.max){
        this.innerValue.test.account.push({
          nickname: `テスト${this.innerValue.test.account.length+1}`,
          location: null,
          status: {
            STR:0, INT:0, VIT:0, MND:0, HP:5, EP:0, DEX:0, AGI:0
          }
        })
      }
    }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  },
  filters: {
    ignoreFixStatus (v) {
      return _.difference(_.keys(v),fixStatus)
    }
  }
}
</script>

<style lang="scss" scoped>
.off {
  background-color: #CCC;
}
</style>
